<template>
  <div class="group-container">
    <div class="bg-wrap"></div>
    <div class="main-wrap">
      <div class="banner-container">
        <img src="../../../assets/images/group/group-banner.jpg" alt="" />
      </div>
      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>新希望集团</span>
          <b class="sub-info">Since 1982</b>
        </p>
      </div>
      <div class="intro-box">
        <div class="intro-box-content">
          <p><br /></p>
          <p>新希望集团是一家以现代农牧与食品产业为主营业务的民营企业集团，</p>
          <p>由著名民营企业家刘永好先生于1982年创立，</p>
          <p>随改革大潮奋斗至今，已拥有世界第一的饲料产能，</p>
          <p>
            中国第一的禽肉加工处理能力，是中国最大的肉、蛋、奶综合供应商之一。<br />
          </p>
          <p><br /></p>
          <p></p>
          <p></p>
          <p>
            <strong style="font-weight: 700"
              >2023年《财富》世界500强榜单第363位。</strong
            >
          </p>
        </div>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>主营业务板块</span>
        </p>
      </div>

      <div class="center-container-wrap">
        <el-row class="section-container">
          <el-col
            :span="6"
            class="business-box"
            data-wow-delay="100ms"
            data-wow-duration="500ms"
          >
            <div
              class="business-item wow animate__bounceIn"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <div>
                <img src="../../../assets/images/group/food.png" alt="" />
                <p class="business-title">农牧食品</p>
                <p class="business-title-en">FARMING &amp; FOOD</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="business-box">
            <div
              class="business-item wow animate__bounceIn"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <div>
                <img src="../../../assets/images/group/milk.png" alt="" />
                <p class="business-title">乳品快消</p>
                <p class="business-title-en">DAIRY &amp; FMCG</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="business-box">
            <div
              class="business-item wow animate__bounceIn"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <div>
                <img src="../../../assets/images/group/town.png" alt="" />
                <p class="business-title">智慧城乡</p>
                <p class="business-title-en">WISDOM OF URBAN &amp; RURAL</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="business-box">
            <div
              class="business-item wow animate__bounceIn"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <div>
                <img src="../../../assets/images/group/world.png" alt="" />
                <p class="business-title">金融投资</p>
                <p class="business-title-en">FINANCE &amp; INVESTMENT</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>全球合作伙伴</span>
        </p>
      </div>
      <div class="center-container-wrap">
        <p class="partner-info">与全球翘楚品牌同行，实现全球资源共享共赢。</p>
        <div class="section-container">
          <el-row>
            <el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/1.png"
                alt=""
              />
            </el-col>
            <el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/2.png"
                alt=""
              />
            </el-col>
            <el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/3.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/4.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/5.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/6.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/7.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/8.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/9.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/10.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/11.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/12.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">&nbsp;</el-col
            ><el-col :span="2" class="partner-img">&nbsp;</el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/13.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/14.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/15.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/16.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/17.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/18.png"
                alt=""
              /> </el-col
            ><el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/19.png"
                alt=""
              />
            </el-col>
            <el-col :span="2" class="partner-img">
              <img
                class="img-responsive"
                src="../../../assets/images/group/20.png"
                alt=""
              />
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>缔造优势</span>
        </p>
      </div>

      <div class="center-container-wrap">
        <div class="section-container">
          <img
            class="img-responsive wow animate_slideInDown"
            data-wow-duration="500ms"
            src="../../../assets/images/group/map.png"
            alt=""
          />
        </div>
        <div class="section-container intro-box">
          <div class="intro-box-content" style="margin-top: 50px">
            <p>
              <br />
            </p>
            <p>
              <span>在40余年的发展历程中，</span>
            </p>
            <p>
              <span>新希望集团立足农牧行业并不断向上、下游产业延伸，</span>
            </p>
            <p>
              <span
                >形成农牧食品、乳品快消、智慧城乡、金融投资等相关产业，</span
              >
            </p>
            <p>
              <span>在全球拥有分子公司超过600家，员工超10万人，</span>
            </p>
            <p>
              <span>2023年销售收入超2,800亿元人民币，</span>
            </p>
            <p>
              <span
                >荣登2023年《财富》世界500强榜单第363位，已连续三年入选该榜单。</span
              >
            </p>
            <p>
              <span>入选2022年、2023年《财富》最受赞赏中国公司。</span>
            </p>
            <p>
              <span>集团主体信用等级由"中诚信"评定为AAA级。</span>
            </p>
            <p>
              <br />
            </p>
            <p>
              <span>从1994年刘永好先生率先倡议发起“光彩事业”产业扶贫，</span>
            </p>
            <p>
              <span
                >到2020年联合“永好公益慈善基金会”启动助力国家乡村振兴战略的“五五工程”，</span
              >
            </p>
            <p>
              <span
                >新希望集团始终扎根三农领域，聚焦民生产业，争做“乡村振兴排头兵”。</span
              >
            </p>
            <p>
              <span
                >未来，新希望集团将继续践行“希望，让生活更美好”的使命，</span
              >
            </p>
            <p>
              <span
                >以
                “五新”理念引领发展，为打造具有世界竞争力的卓越企业而努力奋斗。</span
              ><br />
            </p>
          </div>
        </div>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>企业荣誉</span>
        </p>
      </div>

      <div class="center-container-wrap" style="background-color: transparent">
        <div class="swiper-box section-container">
          <div
            class="section-container section-container-wrap"
            style="background-color: transparent"
          >
            <div
              class="swiper-container"
              ref="swiperRef"
              style="--swiper-theme-color: #00803e"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <p class="title">{{ item.title }}</p>
                  <p class="info" v-html="item.info"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" @click="prev"></div>
          <div class="swiper-button-next" @click="next"></div>
        </div>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>企业文化</span>
        </p>
      </div>

      <div class="center-container-wrap">
        <div class="section-container">
          <p class="culture-info">
            新希望集团奉行阳光、正向、规范、创新的企业价值观。
          </p>
          <el-row :gutter="16">
            <el-col :span="6">
              <div
                class="enterprise-item wow animate_fideIn"
                data-wow-duration="500ms"
              >
                <div class="header-cover">
                  <img
                    class="img-responsive enterprise-item-img"
                    src="../../../assets/images/group/wh1.jpg"
                    alt=""
                  />
                  <div class="enterprise-item-logo">
                    <p>阳光</p>
                    <p>Illuminative</p>
                  </div>
                </div>
                <div class="info-wrap">
                  <p>做事先做人，简单真诚、快乐自信，具备积极心态</p>
                  <p>敢于奉献，为了组织和集体的利益可以成就他人</p>
                  <p>与人为善、充满活力、善于沟通</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="enterprise-item wow animate_fideIn"
                data-wow-duration="500ms"
              >
                <div class="header-cover">
                  <img
                    class="img-responsive enterprise-item-img"
                    src="../../../assets/images/group/wh2.jpg"
                    alt=""
                  />
                  <div class="enterprise-item-logo">
                    <p>正向</p>
                    <p>Positive</p>
                  </div>
                </div>
                <div class="info-wrap">
                  <p>树正气，正人心</p>
                  <p>凡是往好处想，往好处做，就会有好结果</p>
                  <p>&nbsp;</p>
                </div>
              </div> </el-col
            ><el-col :span="6">
              <div
                class="enterprise-item wow animate_fideIn"
                data-wow-duration="500ms"
              >
                <div class="header-cover">
                  <img
                    class="img-responsive enterprise-item-img"
                    src="../../../assets/images/group/wh3.jpg"
                    alt=""
                  />
                  <div class="enterprise-item-logo">
                    <p>规范</p>
                    <p>Normative</p>
                  </div>
                </div>
                <div class="info-wrap">
                  <p>专业负责，勤奋敬业</p>
                  <p>诚实守信，公道正派</p>
                  <p>服务客户，奉献社会</p>
                </div>
              </div> </el-col
            ><el-col :span="6">
              <div
                class="enterprise-item wow animate_fideIn"
                data-wow-duration="500ms"
              >
                <div class="header-cover">
                  <img
                    class="img-responsive enterprise-item-img"
                    src="../../../assets/images/group/wh4.jpg"
                    alt=""
                  />
                  <div class="enterprise-item-logo">
                    <p>创新</p>
                    <p>Innovative</p>
                  </div>
                </div>
                <div class="info-wrap">
                  <p>致力于产品、服务创新，以创新提升核心竞争力</p>
                  <p>改善管理理念、方法，不断改进工作业绩和效果</p>
                  <p>不断创新注重商业模式，弘扬创新精神，不断成长</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="center-container-wrap">
        <div class="section-container">
          <div class="custom-button" @click="goGroup">进入新希望集团官网</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "GroupPage",
  data() {
    return {
      list: [
        {
          title: "1995",
          info: "中国私营企业第一名",
        },
        {
          title: "2007",
          info: "最具全球竞争力的中国企业",
        },
        {
          title: "2008",
          info: "最受赞赏的中国公司<br />首届责任年会内地创富100强",
        },
        {
          title: "2010",
          info: "中国绿色公司百强证书<br />品牌中国华谱奖<br />农业产业化国家重点龙头企业<br />国家科学技术进步奖",
        },
        {
          title: "2011",
          info: "金牛基业长青公司",
        },
        {
          title: "2012",
          info: "福布斯中文版A股最大的100家上市家族企业榜单首位",
        },
        {
          title: "2014",
          info: "国家科学技术进步奖",
        },
        {
          title: "2016",
          info: "首家通过“中国优质乳工程”认证的乳企。为消费者展示了国产奶更高的营养健康追求",
        },
        {
          title: "2017",
          info: "新希望集团以农业领域的龙头企业身份，入选国家第二批双创示范基地",
        },
        {
          title: "2018",
          info: "刘永好董事长作为民营企业家的优秀代表，被党中央国务院评为“改革开放先锋人物” <br />“猪抗病营养技术体系创建与应用”荣获国家科技进步二等奖",
        },
        {
          title: "2019",
          info: "刘永好董事长登上国庆春潮滚滚彩车，展现民营企业家风采",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$refs.swiperRef, {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 20,
        speed: 500,
        autoplayDisableOnInteraction: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    });
  },
  methods: {
    goGroup() {
      window.open("http://www.newhopegroup.com/", "_blank");
    },
    prev() {
      this.swiper.slidePrev();
    },
    next() {
      this.swiper.slideNext();
    }
  },
  beforeDestroy() {
    this.swiper = null;
  },
};
</script>
<style lang="scss" scoped>
.group-container {
  width: 100%;

  .bg-wrap {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: -1;
    background: url("../../../assets/images/group/bg.jpg") no-repeat;
    left: 0;
    top: 0;
    background-size: cover;
    background-position: center center;
  }

  .center-container-wrap {
    background-color: #fff;
  }
  .banner-container {
    width: 100%;
    padding: 0 -15px;
    margin: 0 auto;
    overflow: hidden;

    > img {
      width: 100%;
    }
  }

  .intro-box {
    background-color: #fff;
    .intro-box-content {
      > p {
        text-align: center;
        font-size: 16px;
        color: #565c61;
        font-weight: 300;
        line-height: 35px;
      }
    }
  }

  .sub-info {
    position: absolute;
    left: 50%;
    bottom: 10%;
    transform: translateX(-50%);
    font-weight: normal;
    font-size: 22px;
    color: #3c4347;
    text-align: center;
  }

  .business-box {
    border-top: 1px solid #8cbea0;
    border-left: 1px solid #8cbea0;
    border-bottom: 1px solid #8cbea0;

    &:last-child {
      border-right: 1px solid #8cbea0;
    }
  }

  .business-item {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s linear;

    &:hover {
      background-color: #f5f6f7;
    }

    > div {
      text-align: center;
      color: #3c4347;
      line-height: 28px;
      padding: 25% 0;
    }

    .business-title {
      margin-top: 20px;
      font-size: 22px;
    }

    .business-title-en {
      display: inline-block;
      font-size: 12.5px;
      transform: scale(0.8);
      position: relative;
      left: -12.5%;
      width: 125%;
      line-height: 20px;
      transition: all 0.3s linear;
    }
  }

  .partner-info,
  .culture-info {
    font-size: 16px;
    color: #565c61;
    font-weight: 300;
    line-height: 35px;
    text-align: center;
  }

  .partner-img {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .img-responsive {
    display: block;
    width: 100%;
    height: auto;
  }
  .swiper-box {
    position: relative;
  }
  .swiper-container {
    overflow: hidden;
    box-sizing: border-box;
    padding: 80px 0;
    position: relative;
    width: 1076px;
  }

  .swiper-wrapper {
    width: 810px;
    height: 254px;
  }

  .swiper-slide {
    width: 254px;
    background: #fff;
    opacity: 0.9;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;

    .title {
      font-size: 28px;
      color: #00803e;
      line-height: 42px;
      margin-bottom: 20px;
    }

    .info {
      line-height: 22px;
      color: #565c61;
      text-align: justify;
      display: inline-block;
      font-size: 15px;
      -webkit-transform: scale(0.8);
      transform: scale(0.8);
      position: relative;
      left: -12%;
      width: 124.5%;
    }
  }

  .enterprise-item {
    overflow: hidden;
    border: 1px solid #aaadb0;
    padding-top: 7px;
    padding-left: 7px;
    padding-right: 7px;

    .header-cover {
      width: 100%;
      position: relative;
      overflow: hidden;

      > img {
        transition: all 0.2s linear;
      }
    }

    .enterprise-item-logo {
      position: absolute;
      line-height: 35px;
      font-size: 28px;
      left: 3%;
      bottom: 1%;
      width: 100% !important;
      color: #fff;
    }

    &:hover .header-cover > img {
      transform: scale(1.05);
    }

    .info-wrap {
      box-sizing: border-box;
      padding: 20px 0;
      > p {
        color: #565c61;
        margin-bottom: 6px;
        display: block;
        font-size: 15px;
        transform: scale(0.8);
        width: 125%;
        position: relative;
        margin-left: -33px;
      }
    }
  }

  .culture-info {
    margin-bottom: 30px;
  }

  .custom-button {
    border-radius: 3px;
    width: 288px;
    height: 52px;
    text-align: center;
    font-size: 22px;
    line-height: 52px;
    color: #fff;
    margin-left: auto;
    margin-right: auto;
    background: #00803e;
    margin-top: 50px;
    cursor: pointer;
  }

  ::v-deep {
    .swiper-button-next,
    .swiper-button-prev {
      color: #fff;

      &:hover {
        color: #00803e;
      }
    }
  }
}
</style>
